module.exports = __webpack_public_path__ + "img/image_frame.03fe4dec.png";